import {
  PROJECT_PROFILE_FETCH,
  PROJECT_PROFILE_RESET,
  PROJECT_CREATE,
  PROJECT_FETCH,
  PROJECT_FETCH_SUCCESS,
  PROJECT_FETCH_ERROR,
  PROJECT_UPDATE,
  PROJECT_ARCHIVE,
  PROJECT_UNARCHIVE,
  PROJECT_DELETE,
  PROJECT_FETCH_FILES,
  PROJECT_UPDATE_MILESTONE_TASK,
  PROJECTS_UPDATE_ACTIVITY_FILTERS
} from 'Projects/constants'

export const projectCreate = (payload, { successCallback, failureCallback } = {}) => (
  { payload, type: PROJECT_CREATE, successCallback, failureCallback })
export const projectProfileFetch = payload => ({ payload, type: PROJECT_PROFILE_FETCH })
export const projectFetch = payload => ({ payload, type: PROJECT_FETCH })
export const projectFetchSuccess = payload => ({ payload, type: PROJECT_FETCH_SUCCESS })
export const projectFetchError = payload => ({ payload, type: PROJECT_FETCH_ERROR })
export const projectUpdate = (payload, { successCallback, failureCallback, finallyCallback } = {}) => (
  { payload, type: PROJECT_UPDATE, successCallback, failureCallback, finallyCallback })
export const projectProfileReset = () => ({ type: PROJECT_PROFILE_RESET })
export const projectArchive = (payload, { successCallback, failureCallback } = {}) => (
  { payload, type: PROJECT_ARCHIVE, successCallback, failureCallback })
export const projectUnarchive = (payload, { successCallback, failureCallback } = {}) => (
  { payload, type: PROJECT_UNARCHIVE, successCallback, failureCallback })
export const projectDelete = (payload, { successCallback, failureCallback } = {}) => (
  { payload, type: PROJECT_DELETE, successCallback, failureCallback })

// Files
export const fetchProjectFiles = payload => ({ payload, type: PROJECT_FETCH_FILES })
export const loadProjectFiles = payload => ({ payload, type: 'PROJECTS_LOAD_FILES' })
export const createProjectFile = payload => ({ payload, type: 'PROJECTS_CREATE_FILE' })
export const deleteProjectFile = payload => ({ payload, type: 'PROJECTS_DELETE_FILE' })
export const filterProjectFiles = payload => ({ payload, type: 'PROJECTS_FILTER_FILES' })
export const updateProjectFile = payload => ({ payload, type: 'PROJECTS_UPDATE_FILE' })
export const sortProjectFiles = payload => ({ payload, type: 'PROJECTS_SORT_FILES' })

// Milestone tasks
export const updateMilestoneTask = payload => ({ payload, type: PROJECT_UPDATE_MILESTONE_TASK })

// Activity Filters
export const updateActivityFilters = payload => ({ payload, type: PROJECTS_UPDATE_ACTIVITY_FILTERS })
